export default {
  List: {
    Caption: "Quản lý người dùng",
    AddButton: "Thêm mới",
    SearchPlaceHolder: "Tìm kiếm người dùng",
  },
  Message: {
    Error: "Có lỗi xảy ra. Vui lòng thử lại!",
    EditSuccess: "Lưu người dùng thành công",
    SaveSuccess: "Thêm người dùng thành công",
    DeleteSuccess: "Xóa người dùng thành công",
    UserIsNotActive: "Tài khoản đang ở trạng thái không hoạt động",
    IsExistEmail: "Người dùng đã tồn tại trên hệ thống",
    FullNameNotValidate: "Họ và tên không hợp lệ",
    EmailIsNotActive: "Email chưa được kích hoạt",
    DeleteUserMessage: "Tài khoản này sẽ không thể truy cập trang quản trị JetPay",
    WarningDecentralization: "Tài khoản cần được phân ít nhất 1 quyền",
  },
  grdDetailUser: {
    UserName: "Tên đăng nhập",
    EmployeeCode: "Mã nhân viên",
    FullName: "Họ và tên",
    OrganizationUnitName: "Đơn vị công tác",
    Email: "Email",
    Phone: "Số điện thoại",
    Role: "Vai trò",
    Status: "Trạng thái",
  },
  Detail: {
    AddTitle: "Thêm mới người dùng",
    EditTitle: "Sửa người dùng",
    DuplicateTitle: "Nhân bản người dùng",
    UserName: "Tên đăng nhập",
    FullName: "Họ và tên",
    JobTitle: "Chức danh",
    Description: "Mô tả",
    DetailUser: "Thông tin người dùng",
    EmployeeCode: "Mã nhân viên",
    Phone: "Số điện thoại",
    Email: "Email",
    Name: "Tên",
    Surname: "Họ và đệm",
    Role: "Vai trò",
    AmisUserStatus: "Trạng thái",
    Position: "Chức vụ",
  },
  Permissions: {
    Title: "Phân quyền người dùng",
    Role: {
      Code: "Mã vai trò",
      Name: "Tên vai trò",
    },
    Permissions: {
      Title: "Quyền được truy cập dữ liệu",
    },
    Add: "Thêm vai trò",
    AddUser: "Thêm người dùng",
  },
  Warning: {
    DeleteUser:
      "Người dùng bị xóa sẽ không được tiếp tục làm việc trên Jetpay. Bạn có chắc chắn muốn tiếp tục?",
    ChangeToActive:
      "Người dùng sẽ được chuyển sang trạng thái Đang hoạt động. Bạn có chắc chắn muốn tiếp tục?",
    ChangeToInactive:
      "Người dùng sẽ được chuyển sang trạng thái Ngừng hoạt động. Bạn có chắc chắn muốn tiếp tục?",
    ExistOneSystemManager: "Phải có ít nhất 1 người dùng có vai trò Quản trị ứng dụng Jetpay",
    TooQuantityUser:
      "<p style='margin: 0'>ĐÃ HẾT TÀI KHOẢN SỬ DỤNG</p>Đã mua:  {0}, Đã sử dụng: {1}, Còn lại: {2}.</br>Vui lòng kiểm tra thuê bao và mua thêm để công việc không bị gián đoạn.",
    NotSelectAmisUserStatusInList: "Trạng thái không đúng. Vui lòng chọn trong danh sách.",
    SelectNotEmpty: "Vui lòng chọn ít nhất 1 thành viên",
  },
  Confirm: {
    ExitHasChange: "Dữ liệu đã thay đổi, bạn có muốn cất không?",
    MultiDelete: "Bạn có thực sự muốn xóa những người dùng đã chọn không?",
  },
};
